module.exports = __webpack_public_path__ + "static/media/NexaLight.a731b123.woff2";